import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class CampanhaProdutoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let campanha = model;
        
        if (!campanha.valor) {
            refs.valorInput.focusedOut = true;
            validated = false;
        }
        if (!campanha.valorminimo) {
            refs.valorMinimoInput.focusedOut = true;
            validated = false;
        }
        if (!campanha.idtabpreco) {
            refs.tabprecoSelect.focusedOut = true;
            validated = false;
        }
        if (!campanha.idcampanha) {
            refs.campanhaSelect.focusedOut = true;
            validated = false;
        }
        
        return validated;
    }

}